import React from "react";
import Button from "./Button";
import { ButtonProps as MuiButtonProps } from "@mui/material";

interface CustomButtonProps extends MuiButtonProps {
  // ボタンのプロパティを継承
  children: React.ReactNode; // ボタン内部の要素を受け取る
}

const CustomButton: React.FC<CustomButtonProps> = ({ children, ...props }) => {
  return (
    <Button
      {...props}
      variant="outlined" // ボタンのスタイルをアウトラインに設定
      sx={{
        // スタイルの設定
        width: "300px",
        height: "115px", 
        backgroundColor: (theme) => theme.palette.primary.main, 
        color: (theme) => theme.palette.primary.contrastText,
        typography: { fontSize: "1.5rem", fontWeight: "bold" },
        "&:hover": {
          // マウスがボタンに重なったときのスタイル
          backgroundColor: (theme) => theme.palette.primary.main,
          opacity: 1, 
        },
        "&:active": {
          // ボタンがアクティブなとき（クリック中）のスタイル
          backgroundColor: (theme) => theme.palette.primary.main, 
          opacity: 1, 
        },
        display: "flex", 
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center", 
        ...props.sx,
      }}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
